import { gql } from 'apollo-angular';

export const UPDATE_COMMUNICATION_LANGUAGE = gql`
  mutation UpdateCommunicationLanguage($communicationLanguageCode: String!) {
    updateCommunicationLanguage(
      communicationLanguageQuery: {
        communicationLanguageCode: $communicationLanguageCode
      }
    ) {
      data {
        communicationLanguageCode
      }
      isSuccess
      message
    }
  }
`;
